import { I18nService } from './I18nService';

const i18nServiceInjectionKey = I18nService.injectionKey;
const useI18nService = I18nService.use;

export {
    I18nService,
    i18nServiceInjectionKey,
    useI18nService,
}
export type {
    InterpolationParams,
    ResourcesSource,
    TranslationKey
} from './shared/types';
export type { DateTimeFormat } from './formatters/date-time/types';
export type { NumberFormat } from './formatters/number/types';
